import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { applyDayjsLocale } from "./locales/appLocale";
import {
  DEFAULT_LANGUAGE,
  RTL_LANGUAGES,
  SUPPORTED_LANGUAGES,
  resources,
} from "./locales";

const applyDirection = (lng: string) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
  applyDayjsLocale(lng);
};

const savedLang = localStorage.getItem("language");
const initialLang =
  savedLang && (SUPPORTED_LANGUAGES as readonly string[]).includes(savedLang)
    ? savedLang
    : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: [...SUPPORTED_LANGUAGES],
  interpolation: { escapeValue: false },
});

applyDirection(initialLang);
i18n.on("languageChanged", applyDirection);

export default i18n;
